import {
  Box,
  AppBar,
  Toolbar,
  Typography,
  InputBase,
  styled,
  Divider,
  Stack,
  Paper,
  IconButton,
  
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import logo from "../../images/header-logo.png";
import LocalMallOutlinedIcon from "@mui/icons-material/LocalMallOutlined";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/GlobalState";
import { auth } from "../../firebase";

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: 'inherit',
    ...theme.typography.body2,
    padding: 3,
    textAlign: 'center',
    color:"#fff",
    width:"100%",
    display:"flex",
    justifyContent:"center",
    alignItems:"center",
    marginTop:7
  }));


const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "#fff",
  marginRight: theme.spacing(2),
  marginLeft:theme.spacing(2) ,
  width: "70%",
  color: theme.palette.text.primary,
  [theme.breakpoints.down("md")]: {
    marginLeft: theme.spacing(3),
    width: "45%",
  },
  [theme.breakpoints.down("sm")]: {
    marginLeft: theme.spacing(3),
    display:"none"
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  background: "#e2bc10",
  cursor: "pointer",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),

    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "100%",
    },
  },
}));


export default function Header() {
  const navigate = useNavigate();
  const {user ,basket} = useAuth();
  const dataHeader = [
    { id:1 ,title: `Hello, ${user? user.email.slice(0, 7):"Guest" }`, 
    subTitle: user? "Log out":"Log in" },
    { id:2 ,title: "Returns", subTitle: "& Orders" },
    
  ];
  console.log(user);


  

  return (
    <Box sx={{ flexGrow: 1 , width:"100%" ,
     display:"flex" ,
     flexDirection:"column",
     justifyContent:{xs:"space-between" , md:"unset"}
     }}>
      <AppBar position="static" sx={{ bgcolor: "#0f1111" }}>
        <Toolbar>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ width:{md:"120px" ,xs:"100px"}, mt: 2 , cursor:"pointer"}}
            onClick={()=>navigate("/")}
          >
            <img src={logo} alt="logo" style={{ width:"100%" }} />
          </Typography>
          <Search sx={{ width: "100%" }}>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
              placeholder="Search…"
              inputProps={{ "aria-label": "search" }}
            />
          </Search>
          

          
          <Stack
          width={{xs:"80%" , sm:"40%" , md:"50%" , lg:"23%"}}
          sx={{display:"flex" , justifyContent:"space-between" }}
            direction="row"
            divider={<Divider orientation="vertical" flexItem />}
            gap={{xs:1 }}
          >
              <Stack>
                <Item>Hello, {user? user.email.slice(0,7) : " Guest"}</Item>
                <Item sx={{cursor:"pointer" , fontWeight:"700"}} 
                onClick={()=>{
                  user? auth.signOut() : navigate("/login")
                 }}
                  >{user? "Log out": "Log in"}</Item>
                </Stack>

                <Stack>
                <Item>Returns</Item>
                <Item sx={{cursor:"pointer" , fontWeight:"700"}} 
                onClick={()=>{ navigate("/orders")}}>& Orders</Item>
                </Stack>
                
                <Stack sx={{pb:1}}>
                <IconButton onClick={()=>navigate("/checkout")}>
                    <LocalMallOutlinedIcon  sx={{color:"#fff", fontSize:"28px"}} />
                </IconButton>
                <Typography onClick={()=>navigate("/checkout")}  sx={{cursor:"pointer"}} variant="body2">Cart({basket?.length})</Typography>
                </Stack>
           
          </Stack>
        </Toolbar>
      </AppBar>
      
    </Box>
  );
}
